export const API = "https://foodie-orcx.onrender.com";
// export const API = "http://127.0.0.1:3000";
